import React, { useState } from "react";
import cn from "classnames";
import CONFIG from "../../../../config";

const { LINKS } = CONFIG;

/*SEARCH-PANEL*/
const Search: React.FC = () => {
    const [openForm, setOpenForm] = useState<boolean>(false);

    const openCloseSearchForm = () => setOpenForm(!openForm);

    return (
        <div className="header__bottom__search__cabinet">
            <div className="header__bottom__search">
                <form className={cn({ 'open': openForm })} action={LINKS.BAIBOL.SEARCH} method="GET">
                    <input type="text" name="q" placeholder="Поиск по сайту" />
                </form>
                <span
                    className={cn("header__bottom__search__btn", { 'open': openForm })}
                    onClick={openCloseSearchForm}
                ></span>
            </div>
            <a
                className="header__bottom__cabinet"
                data-title="Мобильное приложение"
                href={LINKS.MOBILE_APP}
                target="_blank"
                rel="noopener noreferrer nofollow"
            > </a>
        </div>
    );
}

export default Search;